import React from "react"
import axios from "axios"
import { API } from "../../API";
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"
import { PORT } from "../../config"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import TaxForm from "./TaxForm"

class TaxDetails extends React.Component {
  state = {
    tfn: "",
    show_enter_tfn: false,
    enter_tfn_disabled: false,
    residence_status: this.props.user.residence_status,
    tax_threshold: this.props.user.tax_threshold,
    has_loan: this.props.user.has_loan,
    has_debt: this.props.user.has_debt,
  }

  componentDidMount() {
    // disabling this for now
    //   if (!this.props.user.bank_details_enabled) {
    //     notify.show("This page is not enabled for you yet.");
    //     this.props.history.push("/Home2");
    //   }

    API.getUserSensitiveData()
      .then(res => {
        // console.log(res.data)
        // this.setState(res.data)
        const { residence_status, tax_threshold, has_loan, has_debt } = res.data.user;
        this.setState({ residence_status, tax_threshold, has_loan, has_debt });
      })
      .catch(err => {
        console.log(err)
      })

    API.getSafeBankData()
      .then(res => {
        // console.log(res.data)
        if (res.data.bank_details && res.data.bank_details.tfn) {
          this.setState({
            tfn: "XXX-XXX-" + res.data.bank_details.tfn,
            show_enter_tfn: true,
            enter_tfn_disabled: true
          });
        }
      })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  setEnterTFN = (value) => {
    this.setState({ show_enter_tfn: value })
  }

  clearTFN = () => {
    this.setState({ enter_tfn_disabled: false, tfn: "" })
  }

  handleRadioChange = (e) => {
    let state
    if (e.target.title === "Yes") {
      state = true
    } else if (e.target.title === "No") {
      state = false
    } else {
      state = e.target.title
    }

    this.setState({ [e.target.name]: state })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = [
      "tfn_select_1",
      "tfn_select_2",
      "tfn",
      "tax_type_1",
      "tax_type_2",
      "tax_type_3",
      "threshold_y",
      "threshold_n",
      "loan_y",
      "loan_n",
      "debt_y",
      "debt_n",
    ]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break
      }
    }

    if (!errors) {
      const { tfn, show_enter_tfn, enter_tfn_disabled, ...state } = this.state

      if (tfn && !enter_tfn_disabled) {
        API.updateBankData({ tfn })
          .then((res) => {
            this.props.updatePersonalDetails({ ...state })
            this.setState({
              tfn: "XXX-XXX-" + tfn.substring(tfn.length - 3),
              show_enter_tfn: true,
              enter_tfn_disabled: true
            });
          })
          .catch((err) => {
            console.error()
            notify.show("Error saving bank details")
          })
      } else {
        this.props.updatePersonalDetails({ ...state })
      }
    }
  }

  tabs = [
    {
      pathname: "/BankDetails",
      text: "Bank Details",
    },
    {
      pathname: "/Tax",
      text: "Tax Declaration",
      active: true,
    },
    {
      pathname: "/Superannuation",
      text: "Superannuation",
    },
  ]

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Payments"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <TaxForm
            handleFormFieldChange={this.handleFormFieldChange}
            handleRadioChange={this.handleRadioChange}
            state={this.state}
            setEnterTFN={this.setEnterTFN}
            clearTFN={this.clearTFN}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { user: state.user.user }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TaxDetails)
